import { createRouter, createWebHistory } from "vue-router";
import { useCustomerStore } from "@/stores/customerStore";

const routes = [
  { path: "/", redirect: "/dashboard" },
  { path: "/dashboard", name: "Dashboard", component: () => import("../views/Dashboard.vue"), meta: { requiresAuth: true } },
  { path: "/welcome", name: "Welcome", component: () => import("../views/Auth/Welcome.vue"), meta: { requiresAuth: true } },
  { path: "/tests", name: "Tests", component: () => import("../views/Tests/Overview.vue"), meta: { requiresAuth: true, navKey: "tests" } },
  { path: "/tests/:testId", name: "TestDetail", component: () => import("../views/Tests/Detail.vue"), meta: { requiresAuth: true, navKey: "tests" } },
  { path: "/analytics", name: "Analytics", component: () => import("../views/Analytics/Overview.vue"), meta: { requiresAuth: true, navKey: "analytics" } },
  { path: "/admin", name: "Admin", component: () => import("../views/Admin/Panel.vue"), meta: { requiresAuth: true, requiresAdminAccess: true } },
  { path: "/ranking", name: "Ranking", component: () => import("../views/Admin/Ranking.vue"), meta: { requiresAuth: true, requiresAdminAccess: true } },
  { path: "/auth/login", name: "Login", component: () => import("../views/Auth/Login.vue"), meta: { requiresGuest: true } },
  { path: "/auth/setup", name: "Setup", component: () => import("../views/Auth/Setup.vue"), meta: { requiresGuest: true } },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({ history: createWebHistory(process.env.BASE_URL), routes });

router.beforeEach(async (to, _from, next) => {
  const cs = useCustomerStore();
  if (!cs.isAuthenticated || !localStorage.getItem("auth_token")) await cs.verifySession();

  // Nicht eingeloggt → Login
  if (to.meta.requiresAuth && !cs.isAuthenticated) return next({ name: "Login" });

  // Eingeloggt → Gastseiten weiterleiten
  if (to.meta.requiresGuest && cs.isAuthenticated) {
    return next({ name: cs.isEmployee ? "Admin" : "Dashboard" });
  }

  // Admin-Bereich: nur Mitarbeiter (staff+admin) oder Kunden-Admin
  if (to.meta.requiresAdminAccess && cs.isAuthenticated && !cs.canAccessAdmin) {
    return next({ name: "Dashboard" });
  }

  // Mitarbeiter (ohne Impersonation) dürfen keine Kunden-Seiten sehen
  if (cs.isEmployee && !cs.impersonating && cs.isAuthenticated && to.meta.requiresAuth && !to.meta.requiresAdminAccess) {
    return next({ name: "Admin" });
  }

  next();
});

export default router;
